import React from "react";

import Popover from "ui/Popover";

import { InfoIcon } from "ui/Icons";

const Tip: React.FunctionComponent<{
  content: React.ReactNode;
  className?: string;
}> = ({ content, className }) => {
  return (
    <Popover content={content}>
      <InfoIcon className={className} />
    </Popover>
  );
};

export default Tip;
